import { adminRepositories } from "data/admin/repositories";

export const provincesRepo = {
  list(params) {
    return adminRepositories.provinces.list(params);
  },

  getById(id) {
    return adminRepositories.provinces.getById(id);
  },

  create(province) {
    return adminRepositories.provinces.create(province);
  },

  update(id, patch) {
    return adminRepositories.provinces.update(id, patch);
  },

  remove(id) {
    return adminRepositories.provinces.remove(id);
  },
  restore(id) {
    return adminRepositories.provinces.restore(id);
  },
};
